export default {
	title: 'Indicateurs',
	url: 'indicateurs',
	subtitle:
		"Listez les indicateurs de succès et organisez-les par catégories — par défaut, les 4 perspectives du Balanced Scorecard : Finance, Clients, Processus internes, Apprentissage et croissance. L'onglet Visualisation les présente en tableau de bord équilibré, avec leur évolution par scénario.",
	no_description: 'Aucun indicateur défini',
	context_worse: 'Négatif',
	context_best: 'Positif',
	tabs: {
		filters: {
			title: 'Filtres'
		},
		general: {
			title: 'Général'
		},
		export: {
			title: 'Exporter'
		},
		comments: {
			title: 'Historique'
		},
		bot: {
			title: 'IA'
		}
	},
	messages: {
		edit_constraint: "Édition de l'indicateur",
		create_constraint: 'Créer un nouvel indicateur'
	},
	onboarding: {
		title: 'Revue des indicateurs',
		description:
			"Vérifiez que les indicateurs couvrent les catégories du Balanced Scorecard et sont rattachés au plan d'action."
	}
};
